module.exports = __webpack_public_path__ + "static/media/12-1.40144374.mp3";